import { createSlice, current } from "@reduxjs/toolkit";
const initialCoderState = {
  coder: [],
  toppers: [],
  code:"",
  currentPage: 1,
  totalPages: 0,
  showCoderState: {
    loading: false,
    error: false,
    successMsg: "",
    errorMsg: [],
    status: null,
  },

  showCodeState: {
    loading: false,
    error: false,
    successMsg: "",
    errorMsg: [],
    status: null,
  },

};
export const leaderboarSlice = createSlice({
  name: "leaderboard",
  initialState: initialCoderState,
  reducers: {
    showLeaderboard(state, actions) {
      switch (actions.payload.type) {
        case "LEADERBOARD_REQUEST": {
          state.showCoderState = {
            loading: true,
            error: false,
            errorMsg: [],
            successMsg: "",
            status: null,
          };
          break;
        }
        case "LEADERBOARD_SUCCESS": {
          state.coder = actions.payload.coder;
          state.toppers = actions.payload.toppers;
          state.totalPages = actions.payload.totalPages;
          state.currentPage = actions.payload.pageNo;
          state.showCoderState = {
            loading: false,
            error: false,
            errorMsg: [],
            successMsg: actions.payload.msg,
            status: null,
          };
          break;
        }
        case "LEADERBOARD_FAIL": {
          state.showCoderState = {
            loading: false,
            error: true,
            errorMsg: actions.payload.errors,
            successMsg: "",
            status: actions.payload.status || 500,
          };
          break;
        }
        case "LEADERBOARD_RESET": {
          state.showCoderState = {
            loading: false,
            error: false,
            errorMsg: [],
            successMsg: "",
            status: null
          };
        }
      }
    },
    addLeaderBoard(state, actions) {
      const searchCoder = state.coder.find(c => c._id === actions.payload.individualCoder._id)
      if(!searchCoder){
        state.coder.push(actions.payload.individualCoder)
      }
    },
    addToStart(state, actions) {
     state.coder = [actions.payload.individualCoder, ...state.coder]
    },
    removeFromStart(state, actions) {
      state.coder.shift();
     },

     showCode(state, actions) {
      switch (actions.payload.type) {
        case "CODE_REQUEST": {
          state.showCodeState = {
            loading: true,
            error: false,
            errorMsg: [],
            successMsg: "",
            status: null,
          };
          break;
        }
        case "CODE_SUCCESS": {
          state.code = actions.payload.code;
          state.showCodeState = {
            loading: false,
            error: false,
            errorMsg: [],
            successMsg: actions.payload.msg,
            status: null,
          };
          break;
        }
        case "CODE_FAIL": {
          state.showCodeState = {
            loading: false,
            error: true,
            errorMsg: actions.payload.errors,
            successMsg: "",
            status: actions.payload.status || 500,
          };
          break;
        }
        case "CODE_RESET": {
          state.showCodeState = {
            loading: false,
            error: false,
            errorMsg: [],
            successMsg: "",
            status: null
          };
        }
      }
    },
  },
});
export const leaderboardActions = leaderboarSlice.actions;
export const loadStudentsActions = (pageNo) => {
  return async (dispatch) => {
    try {
      dispatch(
        leaderboardActions.showLeaderboard({ type: "LEADERBOARD_REQUEST" })
      );
      const response = await fetch(`${process.env.REACT_APP_BACKEND}/user/leaderboard?pageNo=${pageNo ?? 1}&userEmail=${JSON.parse(localStorage.getItem("userData"))?.email ?? -1}`, {
        method: "GET",
      });
      if (!response.ok) {
        throw new Error("could not get response");
      }
      const resData = await response.json();
      if (!resData) {
        throw new Error("could not load products");
      }
      const studentIdx = resData.coder.findIndex(c => c._id === JSON.parse(localStorage.getItem("userData"))?.id)
      if(resData.coder[studentIdx]?.error){
        dispatch(
          leaderboardActions.showLeaderboard({
            type: "LEADERBOARD_FAIL",
            status: 499,
            errors: [resData.coder[studentIdx]?.error],
          })
        );
        return
      }
      dispatch(
        leaderboardActions.showLeaderboard({
          type: "LEADERBOARD_SUCCESS",
          coder: resData.coder,
          toppers: resData.toppers,
          msg: resData.message,
          totalPages: resData.totalPages,
          pageNo
        })
      );
    } catch (err) {
      // error handling
      dispatch(
        leaderboardActions.showLeaderboard({
          type: "LEADERBOARD_FAIL",
          errors: [err.message],
        })
      );
    }
  };
};

export const loadCodeActions = (userId) => {
  return async (dispatch) => {
    try {
      dispatch(
        leaderboardActions.showCode({ type: "CODE_REQUEST" })
      );
      const response = await fetch(`${process.env.REACT_APP_BACKEND}/user/show-code?userId=${userId}`, {
        method: "GET",
      });
      if (!response.ok) {
        throw new Error("could not get response");
      }
      const resData = await response.json();
      if (!resData) {
        throw new Error("could not load codes");
      }
      dispatch(
        leaderboardActions.showCode({
          type: "CODE_SUCCESS",
          code: resData.code,
          msg: resData.message,
        })
      );
    } catch (err) {
      // error handling
      dispatch(
        leaderboardActions.showCode({
          type: "CODE_FAIL",
          errors: [err.message],
        })
      );
    }
  };
};